import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/**
 * API for managing agent workspaces
 *
 * @see {@link ec.models.Api}
 */
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context =>
      context
        ? gql.queries.listWorkspaces.executor({
            tenantId: context.tenantId,
            zoneId: context.zoneId,
          })
        : rxjs.of([]),
  )

  /** @inheritdoc */
  public get: ec.models.Api<TypeParams>['get'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.queries.getWorkspace.executor({
      id,
      tenantId: context.tenantId,
      zoneId: context.zoneId,
    })
  }

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (context, entity) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.putWorkspace.executor({
      input: {
        description: entity.description,
        name: entity.name,
      },
      tenantId: context.tenantId,
      zoneId: context.zoneId,
    })
  }

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.deleteWorkspace.executor({
      id,
      tenantId: context.tenantId,
      zoneId: context.zoneId,
    })
  }

  /** @inheritdoc */
  public update: ec.models.Api<TypeParams>['update'] = (
    context,
    { id, updates },
  ) => {
    TypeAsserter.assertIsNotNullish(context)
    TypeAsserter.assertIsNotNullish(updates.name)

    return gql.mutations.putWorkspace.executor({
      input: {
        description: updates.description,
        id,
        name: updates.name,
        sharedWith: updates.sharedWith,
      },
      tenantId: context.tenantId,
      zoneId: context.zoneId,
    })
  }
}
